import type { ElementType, HTMLAttributes } from "react";

type CardPadding = "none" | "sm" | "md" | "lg";

const PADDING: Record<CardPadding, string> = {
  none: "",
  sm: "p-3",
  md: "p-4",
  lg: "p-5",
};

interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  padding?: CardPadding;
}

export default function Card({ as: Tag = "div", padding = "md", className = "", children, ...rest }: CardProps) {
  return (
    <Tag className={`rounded-xl border border-gray-200 bg-white ${PADDING[padding]} ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
